export enum TopBarTestIDs {
  LOGIN = 'login-btn',
  SIGNUP = 'signup-btn',
  LOADER = 'loader',
  LANGUAGE_SELECTOR = 'top-bar-lang',
  MENU_BTN = 'topbar_menu_btn',
  LOGO = 'topbar_logo',
  PROFILE_BTN = 'topbar_profile_btn'
}
